export default {
  state: {
    report: null,
    selected_el_no: null,
    // report: {
    //   birthday: '1996-01-01',
    //   contact: '01075273882',
    //   obstacle: false,
    //   rp_name: '양준석',
    //   rp_result: [{
    //     dir: null,
    //     el_avg_angle: 45,
    //     el_name: 'Flexion',
    //     el_no: 9,
    //     el_parent_name: 'Neck',
    //     response: null
    //   }],
    //   sex: 'male',
    //   type: 'own'
    // }
  },
  getters: {
    report: (state) => state.report,
    selected_el_no: (state) => state.selected_el_no,
  },
  mutations: {
    setClearReport(state, payload) {
      state.report = null;
    },
    setInitReport(state, payload) {
      if (!state.report) state.report = payload;
    },
    setReportSex(state, payload) {
      state.report.sex = payload.sex;
    },
    setReportResult(state, payload) {
      if (!state.report.rp_result) state.report.rp_result = payload.rp_result;
      else {
        state.report.rp_result = state.report.rp_result.filter((x) => {
          let isExist = false;
          payload.rp_result.forEach((y) => {
            if (x.el_no === y.el_no) isExist = true;
          });
          return isExist;
        });
        payload.rp_result.forEach((x) => {
          let isExist = false;
          state.report.rp_result.forEach((y) => {
            if (x.el_no === y.el_no) isExist = true;
          });
          if (!isExist) state.report.rp_result.push(x);
        });
        state.report.rp_result.sort((a, b) => {
          return a.el_no - b.el_no;
        });
      }
    },
    setReportUhrNo(state, payload) {
      state.report.rp_result.forEach((x) => {
        if (x.el_no === payload.el_no) x.uhr_no = payload.uhr_no;
      });
    },
    setReportResponse(state, payload) {
      state.report.rp_result.forEach((x) => {
        if (x.uhr_no === payload.uhr_no) x.response = payload.response;
      });
    },
    setSelectedReport(state, payload) {
      state.selected_el_no = payload.el_no;
    },
    setReportResponseError(state, payload) {
      state.report.rp_result.forEach((x) => {
        if (x.el_no === state.selected_el_no) x.response = payload.response;
      });
    },
  },
  actions: {
    async clearReport({ commit }, payload) {
      commit("setClearReport", payload);
    },
    async updateStepInit({ commit }, payload) {
      commit("setInitReport", payload);
    },
    async updateSex({ commit }, payload) {
      commit("setReportSex", payload);
    },
    async updateResult({ commit }, payload) {
      commit("setReportResult", payload);
    },
    async updateUhrNo({ commit }, payload) {
      commit("setReportUhrNo", payload);
    },
    async updateStepResponse({ commit }, payload) {
      commit("setReportResponse", payload);
    },
    /* 측정실패용 */
    async selectEvaluation({ commit }, payload) {
      commit("setSelectedReport", payload);
    },
    async updateStepResponseError({ commit }, payload) {
      commit("setReportResponseError", payload);
    },
  },
};
